var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"overlay fixed"},[_c('div',{staticClass:"mask-wrapper relative",on:{"click":_vm.close}},[_c('div',{staticClass:"slot absolute",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }